import { languages } from './i18n';

const config = {
  useFixtures: process.env.REACT_APP_USE_FIXTURES === 'true',
  reduxLogging: process.env.REACT_APP_REDUX_LOGGING === 'true',
  dev: process.env.NODE_ENV === 'development',
  languages,
  maxNumberOfChildren: 30,
  isStandalone: process.env.REACT_APP_RUN_AS_STANDALONE === 'true',
  supportedDocTypes: [
    'image/png',
    'image/jpg',
    'image/jpeg',
    'image/tiff',
    'image/bmp',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],
  lengthsOfStay: [
    {
      uuid: 3,
      nameLangDefault: '3 days',
      nameAltLangOne: '3 jours',
      nameAltLangTwo: '3 days - German',
    },
    {
      uuid: 30,
      nameLangDefault: '1 month',
      nameAltLangOne: '1 mois',
      nameAltLangTwo: '1 Monat',
    },
    {
      uuid: 90,
      nameLangDefault: '3 months',
      nameAltLangOne: '3 mois',
      nameAltLangTwo: '3 Monate',
    },
    {
      uuid: 180,
      nameLangDefault: '6 months',
      nameAltLangOne: '6 mois',
      nameAltLangTwo: '3 Monate',
    },
    {
      uuid: 365,
      nameLangDefault: '1 year',
      nameAltLangOne: '1 an',
      nameAltLangTwo: '1 Jahr',
    },
    {
      uuid: 730,
      nameLangDefault: '2 years',
      nameAltLangOne: '2 ans',
      nameAltLangTwo: '2 Jahr',
    },
  ],
  genders: [
    {
      uuid: 'male',
      nameLangDefault: 'Male',
      nameAltLangOne: 'Homme',
      nameAltLangTwo: 'Männlich',
    },
    {
      uuid: 'female',
      nameLangDefault: 'Female',
      nameAltLangOne: 'Femme',
      nameAltLangTwo: 'Frau',
    },
  ],
  relationshipStatuses: [
    {
      uuid: 'single',
      nameLangDefault: 'Single',
      nameAltLangOne: 'Célibataire',
      nameAltLangTwo: 'Unverheiratete',
    },
    {
      uuid: 'married',
      nameLangDefault: 'Married',
      nameAltLangOne: 'Marié',
      nameAltLangTwo: 'Verheiratet',
    },
    {
      uuid: 'widowed',
      nameLangDefault: 'Widowed',
      nameAltLangOne: 'Veuf',
      nameAltLangTwo: 'Verwitwet',
    },
    {
      uuid: 'divorced',
      nameLangDefault: 'Divorced',
      nameAltLangOne: 'Divorcé',
      nameAltLangTwo: 'Geschieden',
    },
  ],
  modesOfTransport: [
    {
      uuid: 'car',
      nameLangDefault: 'Car',
      nameAltLangOne: 'Voiture',
      nameAltLangTwo: 'Auto',
    },
    {
      uuid: 'airplane',
      nameLangDefault: 'Airplane',
      nameAltLangOne: 'Avion',
      nameAltLangTwo: 'Flugzeug',
    },
    {
      uuid: 'ship',
      nameLangDefault: 'Ship',
      nameAltLangOne: 'Navire',
      nameAltLangTwo: 'Schiff',
    },
  ],
  applicationStatuses: {
    COMPLETED: {
      uuid: 'COMPLETED',
      nameLangDefault: 'Processing Payment',
      nameAltLangOne: 'Paiement en cours de traitement',
      nameAltLangTwo: 'Zahlung in bearbeitung ',
    },
    SUBMITTED: {
      uuid: 'SUBMITTED',
      nameLangDefault: 'Submitted',
      nameAltLangOne: 'Soumis',
      nameAltLangTwo: 'Eingereicht',
    },
    CANCELED: {
      uuid: 'CANCELLED',
      nameLangDefault: 'Payment Rejected',
      nameAltLangOne: 'Paiement Rejeté',
      nameAltLangTwo: 'Zahlung Abgelehnt',
    },
    CANCELLED: {
      uuid: 'CANCELLED',
      nameLangDefault: 'Archived',
      nameAltLangOne: 'Archivé',
      nameAltLangTwo: 'Archiviert',
    },
    READY_FOR_PROCESSING: {
      uuid: 'READY_FOR_PROCESSING',
      nameLangDefault: 'Ready For Processing',
      nameAltLangOne: 'Prêt Pour le Traitement',
      nameAltLangTwo: 'Bereit',
    },
    IN_PROCESSING: {
      uuid: 'IN_PROCESSING',
      nameLangDefault: 'In Processing',
      nameAltLangOne: 'En Traitement',
      nameAltLangTwo: 'In Bearbeitung',
    },
    AWAITING_APPLICANT_FEEDBACK: {
      uuid: 'AWAITING_APPLICANT_FEEDBACK',
      nameLangDefault: 'Awaiting Applicant Feedback',
      nameAltLangOne: "En attente d'un retour de Candidat",
      nameAltLangTwo: 'Erwarte Rückantwort',
    },
    APPROVED: {
      uuid: 'APPROVED',
      nameLangDefault: 'Approved',
      nameAltLangOne: 'Approuvé',
      nameAltLangTwo: 'Genehmigt',
    },
    REJECTED: {
      uuid: 'REJECTED',
      nameLangDefault: 'Rejected',
      nameAltLangOne: 'Rejeté',
      nameAltLangTwo: 'Abgelehnt',
    },
    IN_CREATION: {
      uuid: 'IN_CREATION',
      nameLangDefault: 'In Creation',
      nameAltLangOne: 'En Création',
      nameAltLangTwo: 'In Erstellung',
    },
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/conf/index.js